<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/product/bankheader.png" alt="" />
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 > 产品与解决方案>智能银行解决方案</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <div style="margin-bottom: 10px">方案概述</div>
      <p>
        智慧网点不是高科技产品的堆砌和展示，业务流程再造和网点转型才是核心。智慧银行首先是将传统物理网点
      </p>
      <p>
        与移动互联网金融相结合，是全渠道智能化的客户体验中心。智慧银行应采用互联网理念和技术，
      </p>
      <p>
        具有多功能、
        大数据、020特性。科学合理的建设标准、机具配置、服务内容、业务处理、
      </p>
      <p>岗位设置、考核评价等是保障智能服务模式稳步推进的必要条件。</p>
      <div class="title">建设理念</div>
      <div>
        <img src="../assets/product/bank1.png" alt="" />
      </div>
      <div class="title">技术平台</div>
      <div>
        <img src="../assets/product/bank2.png" alt="" />
      </div>
      <!-- <div class="title">案例</div>
      <div class="flex">
        <div>
          <img style="border: solid 1px #ccc;" src="../assets/product/fuxinbank.png" alt="">
        </div>
        <div>
          <img style="border: solid 1px #ccc;" src="../assets/product/JHbank.png" alt="">
        </div>
      </div> -->
      <div class="title">相关资料</div>
      <div class="flex">
        <img
          style="width: 400px; height: 250px; margin-right: 30px"
          src="../assets/product/bank6.png"
          alt=""
        />
        <div style="width: 30%; text-align: left">
          <p class="flex-title">《智慧银行解决方案》</p>
          <p class="flex-font">
            智慧银行生态运营管控平台是整体的后台系统管
            控平台，可对营业厅所有智能终端设备进行统一管
            理，并有效管理多个功能应用模块，实现人脸识别
            、精准营销、微信公众号内容管理及远程视频会议、
            物联网、直播系统、互动体感游戏功能等。
          </p>
          <div class="flex-button" @click="downLoad()">立即下载</div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
export default {
  name: "",
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    // 下载文件
    downLoad(){
      let pdfUrl = 'https://oss.zijingshuke.com/1724375675757.pdf' 
      fetch(pdfUrl)
        .then((response) => response.blob())
        .then((blob) => {
          var ua = window.navigator.userAgent.toLowerCase();
          if (ua.indexOf("micromessenger") > -1) {
            return true; // 是微信端
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = decodeURIComponent('雅格智慧银行产品手册'.split("/").pop());
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            return false;
          }
        })
        .catch((error) => {
          console.error(error);
        });
      // axios
      //   .get("/download?fileCode=bank", {
      //     responseType: "blob", // 设置响应类型为blob
      //   })
      //   .then((response) => {
      //     console.log(response.data)
      //     // 假设后端返回的文件数据流存储在response中
      //     let blob = new Blob([response.data], { type: "application/pdf" });

      //     let url = window.URL.createObjectURL(blob);
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", "雅格智慧银行产品手册.pdf"); // 设置下载文件的文件名为filename.pdf
      //     document.body.appendChild(link);
      //     link.click();
      //     window.URL.revokeObjectURL(url);
      //   })
      //   .catch((error) => {
      //     console.error("Error fetching file data:", error);
      //   });
    }
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;

  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    img {
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    background: #f5f5fa;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .main {
    width: 100%;
    // background: #F5F5FA;
    cursor: pointer;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405c80;
    padding: 60px 0;
    box-sizing: border-box;
    font-size: 28px;
    .title {
      margin: 60px auto;
    }
    p {
      color: #8d9bb9;
      font-size: 20px;
    }
    img {
      width: 55%;
      height: auto;
    }
    .flex {
      display: flex;
      justify-content: center;
      img {
        width: 30%;
        margin: 0 10px;
      }
      .flex-title {
        font-weight: bold;
        font-size: 30px;
        color: #405680;
      }
      .flex-font {
        font-weight: bold;
        font-size: 18px;
        color: #405680;
        margin: 40px auto 20px;
        text-align: left;
      }
      .flex-button {
        width: 100px;
        height: 35px;
        background: #1473eb;
        border-radius: 3px;
        text-align: center;
        line-height: 35px;
        font-weight: bold;
        font-size: 18px;
        color: #f1f4f8;
      }
    }
  }
}
</style>
